<template>
  <div>
    <KeepAlive>
      <component
        v-if="currentEvent && currentEvent !== 'EnviarNotificacao'"
        :ref="currentEvent.name"
        v-bind:is="currentEvent"
        :card="card"
        :selectedCards="[card.id]"
        :modalType="'add'"
        :eventManager="{ cascate: true, hasNext: this.events.length > 1 }"
        @Submit="handleOk"
        @Abort="$emit('Aborted')"
      ></component>
    </KeepAlive>
  </div>
</template>

<script>
import { createNewFollowUpWithEventId } from '@/components/tools/FollowupTools.js'
import { createSerasaMessage } from '@/components/tools/SerasaTools.js'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import ConsultaSerasa from '@/shared/http/repositories/serasa/consultaSerasa.js'
import { toast } from '@/shared/utils/UIHelper'

import eventoD from '@/components/UI/confirmation/addConfirmation.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import eventoC from '@/views/private/cobranca/modal/asign/addAsign.vue'
import eventoA from '@/views/private/crm/details/followup/followup.vue'
import eventoB from '@/views/private/crm/details/product/modal/productmodal.vue'
import notificationscard from '../../../../../../shared/http/repositories/crm/notificationscard'
import sendMessage from '../../../../../../shared/http/repositories/crm/sendMessage'

const events = {
  1: eventoA,
  2: eventoB,
  3: eventoC,
  4: eventoD,
  5: 'MovimentacaoAutomatica',
  6: 'EnviarNotificacao',
  7: eventoD,
  8: 'BloqueiaAjuizamento'
}

export default {
  name: 'EventManager',
  mixins: [ActionsForm],
  data () {
    return {
      events: [],
      submitEvents: [],
      currentEvent: null,
      pageIndex: 0,
      pageLimit: 12
    }
  },
  props: {
    eventsToShow: Array,
    card: Object,
    colunaDestino: null
  },
  created () {
    this.events = [...this.eventsToShow]
  },

  watch: {
    events: function (newVal) {
      this.currentEvent = events[this.events[0]]
      if (this.currentEvent.name === 'ProductModal') {
        this.$nextTick(() => {
          this.$refs.ProductModal.showModal() // OPEN THE COMPONENT MODAL
        })
      } else if (this.currentEvent.name === 'AddAsignModal') {
        this.$nextTick(() => {
          this.$refs.AddAsignModal.showModal() // OPEN THE COMPONENT MODAL
        })
      } else if (
        this.currentEvent.name === 'AddConfirmation' &&
        this.events[0] === 4
      ) {
        this.$nextTick(() => {
          this.$refs.AddConfirmation.warnText =
            'A movimentação irá gerar consulta ao serasa. Deseja salvar?'
          this.$refs.AddConfirmation.saveFunction = this.searchSerasa
          this.$refs.AddConfirmation.showModal()
        })
      } else if (this.currentEvent === 'EnviarNotificacao') {
        this.$nextTick(() => {
          let data = {
            cardId: this.card.id,
            usuariosID: this.colunaDestino.usuarioList,
            agendamento: false,
            fromBoardColumn: true
          }
          notificationscard.Create(data).then(() => {
            if (this.events.length > 1) this.handleNext()
            else this.$emit('Submited')
          })
        })
      } else if (
        this.currentEvent.name === 'AddConfirmation' &&
        this.events[0] === 7
      ) {
        this.$nextTick(() => {
          this.$refs.AddConfirmation.warnText =
            'A movimentação irá iniciar uma conversa via WhatsApp. Deseja salvar?'
          this.$refs.AddConfirmation.saveFunction = this.sendWhatsApp
          this.$refs.AddConfirmation.showModal()
        })
      } else if (
        this.currentEvent === 'MovimentacaoAutomatica' ||
        this.currentEvent === 'BloqueiaAjuizamento'
      ) {
        if (this.events.length > 1) this.handleNext()
        else this.$emit('Submited')
      }
    }
  },
  methods: {
    handleOk (event) {
      this.submitEvents.push(event) // PUSHES A FUNCTION SENT VIA EMIT INTO THE ARRAY
      // IF THERE'S NO PENDENT EVENT, SUBMIT ALL
      if (this.events.length > 1) {
        this.handleNext()
      } else this.handleSubmit()
    },
    handleNext () {
      this.events.shift() // REMOVES THE FIRST EVENT
    },
    handleSubmit () {
      Promise.all(this.submitEvents.map((event) => event()))
        .then(() => {
          this.$emit('Submited')
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async searchSerasa () {
      let document = this.card.pessoa.document
      if (document) {
        if (this.validateCpf(document)) {
          try {
            const response = await ConsultaSerasa.ConsultBureau(
              this.card.pessoa.document
            )
            let message = await createSerasaMessage(response.data)
            setTimeout(() => {
              createNewFollowUpWithEventId(
                this.card.pessoa.document,
                this.colunaDestino.eventoDTO.id,
                message,
                this.ip,
                this.latitude,
                this.longitude,
                this.card.id
              )
            }, 100)
          } catch (err) {
            console.error('err', err)
            this.onException(err)
          } finally {
          }
        } else if (this.validateCnpj(document)) {
          try {
            const response = await ConsultaSerasa.Relato(
              this.card.pessoa.document
            )
            let message = await createSerasaMessage(response.data)
            setTimeout(() => {
              createNewFollowUpWithEventId(
                this.card.pessoa.document,
                this.colunaDestino.eventoDTO.id,
                message,
                this.ip,
                this.latitude,
                this.longitude,
                this.card.id
              )
            }, 100)
          } catch (err) {
            console.error('err', err)
            this.onException(err)
          } finally {
          }
        } else {
          createNewFollowUpWithEventId(
            this.card.pessoa.document,
            this.colunaDestino.eventoDTO.id,
            'Documento inválido para consulta no serasa',
            this.ip,
            this.latitude,
            this.longitude,
            this.card.id
          )
        }
      }
    },
    async getAssociate (document) {
      try {
        const response = await AssociateRepository.GetByDocument(
          document,
          this.pageLimit,
          this.pageIndex
        )
        return response.data.content[0] // Ensure you're accessing the correct path
      } catch (error) {
        toast.error('Erro na busca pelo associado.')
        throw new Error('Failed to get associate') // Throw an error to handle it in sendWhatsApp
      }
    },
    async sendWhatsApp () {
      try {
        let celular = this.lastCelularNumber(this.card.pessoa.telefone)
        let nome = this.card.pessoa.nome
        let protocolo = this.card.protocolo
        console.log(this.colunaDestino)
        let hsmEntityId = this.colunaDestino.hsmVinculado
          ? this.colunaDestino.hsmVinculado.id
          : null
        let modeloEntityId = this.colunaDestino.modeloVinculado
          ? this.colunaDestino.modeloVinculado.id
          : null
        let provedorId = this.colunaDestino.provedorVinculado
          ? this.colunaDestino.provedorVinculado.id
          : null
        let associate = await this.getAssociate(this.card.pessoa.document)
        let nomeGerente = associate
          ? associate.gerenteSisBR
            ? associate.gerenteSisBR.pessoa.nome
            : associate.gerenteRelacionamento
              ? associate.gerenteRelacionamento.pessoa.nome
              : null
          : null

        if (!nome) {
          return toast.error(
            'Nome da pessoa não cadastrado',
            'Mensagem não enviada!'
          )
        }
        if (!celular) {
          return toast.error(
            'Telefone celular não cadastrado',
            'Mensagem não enviada!'
          )
        }
        let data = {
          name: nome,
          phone: celular,
          hsmEntityId: hsmEntityId,
          modeloEntityId: modeloEntityId,
          protocolo: protocolo,
          nomeGerente: nomeGerente,
          provedorId: provedorId
        }
        await sendMessage.sendWhatsApp(data)
        toast.success('Mensagem enviada com sucesso', 'Mensagem enviada!')
      } catch (error) {
        console.error('Error in sending WhatsApp message:', error)
        toast.error('Erro ao enviar mensagem', 'Erro!')
      }
    },
    lastCelularNumber (celularList) {
      let lastNumber
      celularList.forEach((obj) => {
        if (obj.tipoContato === 'CELULAR' && obj.telefone) {
          lastNumber = obj.telefone
        }
      })

      return lastNumber
    },
    validateCpf (document) {
      // Verifica se o CPF tem 11 dígitos
      if (document.length !== 11) {
        return false
      }
      if (typeof document !== 'string') return false
      if (
        !document ||
        document === '00000000000' ||
        document === '11111111111' ||
        document === '22222222222' ||
        document === '33333333333' ||
        document === '44444444444' ||
        document === '55555555555' ||
        document === '66666666666' ||
        document === '77777777777' ||
        document === '88888888888' ||
        document === '99999999999'
      ) {
        return false
      }
      let soma = 0
      let resto
      for (let i = 1; i <= 9; i++) {
        soma = soma + parseInt(document.substring(i - 1, i)) * (11 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(document.substring(9, 10))) {
        return false
      }

      soma = 0
      for (let i = 1; i <= 10; i++) {
        soma = soma + parseInt(document.substring(i - 1, i)) * (12 - i)
      }
      resto = (soma * 10) % 11
      if (resto === 10 || resto === 11) resto = 0
      if (resto !== parseInt(document.substring(10, 11))) {
        if (resto === 0) return true
        return false
      }
      return true
    },
    validateCnpj (document) {
      if (typeof document !== 'string') return false
      if (
        !document ||
        document.length !== 14 ||
        document === '00000000000000' ||
        document === '11111111111111' ||
        document === '22222222222222' ||
        document === '33333333333333' ||
        document === '44444444444444' ||
        document === '55555555555555' ||
        document === '66666666666666' ||
        document === '77777777777777' ||
        document === '88888888888888' ||
        document === '99999999999999'
      ) {
        return false
      }

      // Valida DVs
      let tamanho = document.length - 2
      let numeros = document.substring(0, tamanho)
      let digitos = document.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado !== parseInt(digitos.charAt(0))) {
        return false
      }

      tamanho = tamanho + 1
      numeros = document.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) {
          pos = 9
        }
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado !== parseInt(digitos.charAt(1))) {
        return false
      }
      return true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/event/EventManager.vue